'use strict';

var footinch = require('footinch');

module.exports = function () {
    return {
        parseInchString: function parseInchString(string) {
            var inch = '',
                frac = '';

            string = string.replace('"', '');
            string = string.trim();

            var components = string.split(' ');

            if (components.length === 1 && components[0].indexOf('/') !== -1) {
                frac = components[0];

                return footinch.parse.F(frac + '"');
            } else if (components.length === 1) {
                inch = components[0];

                if (parseInt(inch) === 0) return 0.0;

                return footinch.parse.F(inch + '"');
            }

            if (components[1].indexOf('/') === -1) {
                return footinch.parse.F(components[0] + '"'); // fractional can not be a number
            }

            return footinch.parse.F(string + '"');
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./server/models/inch-pound/lib/inch-parser.js
// module id = 188
// module chunks = 0